<template>
  <section class="all-cases-view" id="user-account-list">
    <div class="navbarComponent">
      <el-row justify="center">
        <el-col :span="20">
          <div class="container-default">
            <div class="listings-navbar">
              <el-row>
                <el-col :lg="7">
                  <ul class="d-flex list-items-group-15 barcode-print">
                    <li v-if="hasPermission('user_accounts', 'add')">
                      <el-button class="btn button-with-icon" @click="addUser">
                        <span class="mr-8">
                          <img
                            src="@/assets/images/icons/plus-icon.svg"
                            alt="icon"
                            class="inactive"
                          />
                          <img
                            src="@/assets/images/icons/plus-icon-white.svg"
                            alt="icon"
                            class="active"
                          />
                        </span>
                        <span>ADD USER</span>
                      </el-button>
                    </li>
                  </ul>
                </el-col>
                <el-col :lg="17">
                  <ul
                    class="d-flex flex-wrap justify-content-end list-items-group-15"
                  >
                    <li>
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="searchBy"
                          clearable
                          filterable
                          default-first-option
                          :reserve-keyword="false"
                          placeholder="Select Search"
                          @change="clearInputSearch"
                        >
                          <el-option
                            v-for="item in searchOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                        <span class="search-icon">
                          <img
                            src="@/assets/images/icons/search-icon-with-bg-red.svg"
                            alt="icon"
                            class="img-fluid"
                          />
                        </span>
                      </div>
                    </li>

                    <li v-if="searchBy == 'hospital'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="hospital"
                          placeholder="Select Ordering Facility"
                          @change="getAutoCompleteUserAccounts()"
                          :filterable="true"
                          :clearable="true"
                          @focus="fetchAllHospitals"
                          default-first-option
                          :loading="hospitalsLoading"
                        >
                          <el-option
                            v-for="(hospital, index) of hospitalsData.data"
                            :key="index"
                            :value="hospital._id"
                            :label="hospital.name"
                          ></el-option>
                        </el-select>
                        <span class="search-icon">
                          <img
                            src="@/assets/images/icons/search-icon-with-bg-red.svg"
                            alt="icon"
                            class="img-fluid"
                          />
                        </span>
                      </div>
                    </li>
                    <li v-else-if="searchBy == 'user_type'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          placeholder="Select User Type"
                          v-model="userType"
                          @change="getAutoCompleteUserAccounts()"
                          filterable
                          clearable
                          default-first-option
                        >
                          <el-option-group
                            v-for="group of getUserTypes"
                            :key="group.label"
                            :label="group.label"
                          >
                            <el-option
                              v-for="item in group.options"
                              :key="item.value"
                              :label="item.name"
                              :value="item.value"
                            >
                            </el-option>
                          </el-option-group>
                        </el-select>
                        <span class="search-icon">
                          <img
                            src="@/assets/images/icons/search-icon-with-bg-red.svg"
                            alt="icon"
                            class="img-fluid"
                          />
                        </span>
                      </div>
                    </li>
                    <li v-else-if="searchBy == 'case_types'">
                      <div class="form-element search-with-filter-input">
                        <el-select
                          v-model="caseType"
                          placeholder="Select"
                          filterable
                          clearable
                          @change="handleCurrentChange(1)"
                          default-first-option
                        >
                          <el-option
                            v-for="caseType in caseTypes"
                            :key="caseType"
                            :label="caseType.label"
                            :value="caseType.value"
                          >
                          </el-option>
                        </el-select>
                        <span class="search-icon">
                          <img
                            src="@/assets/images/icons/search-icon-with-bg-red.svg"
                            alt="icon"
                            class="img-fluid"
                          />
                        </span>
                      </div>
                    </li>
                    <li
                      v-else-if="searchBy == 'name' || searchBy == 'username'"
                    >
                      <div class="form-element input-with-icon search-input-lg">
                        <el-input
                          placeholder="Search"
                          v-model="search_string"
                          @input="getAutoCompleteUserAccounts()"
                          :clearable="true"
                        ></el-input>
                        <span>
                          <img
                            src="@/assets/images/icons/search-icon-with-bg-red.svg"
                            alt="icon"
                            class="img-fluid icon"
                          />
                        </span>
                      </div>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row justify="center">
      <el-col :span="20">
        <div class="container-default" style="padding-top: 0">
          <!-- Web Version -->

          <div class="primary-content-view-new" v-loading="loading">
            <div
              class="listings listings__table listings__all-cases"
              id="all-cases-listings"
            >
              <el-table
                :data="allUserAccounts.data"
                height="calc(100vh - 200px)"
                :default-sort="{
                  prop: orderBy,
                  order: orderType == 'asc' ? 'ascending' : 'descending',
                }"
                @sort-change="onChangeSort"
              >
                <el-table-column
                  prop="first_name"
                  max-width="200"
                  label="USER"
                  sortable="custom"
                  fixed
                >
                  <template #default="scope">
                    <div>
                      <span class="cursor" @click="onEdit(scope.row)">
                        {{ scope.row.first_name }} {{ scope.row.last_name }}
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="user_type" label="ROLE" max-width="200">
                  <template #default="scope">
                    <span class="text-center ordering_facility-value">
                      {{ userTypeMap[scope.row.user_type] }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="USERNAME"
                  max-width="180"
                  sortable="custom"
                >
                  <template #default="scope">
                    <div>
                      {{ scope.row.username }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Status"
                  prop="status"
                  width="150"
                  sortable="custom"
                >
                  <template v-slot="scope">
                    <div class="column-status">
                      <el-dropdown
                        class="status-dropdown"
                        @command="
                          (command) =>
                            changeStatus(command, scope.row._id, scope.$index)
                        "
                        trigger="click"
                      >
                        <span class="el-dropdown-link cursor">
                          <el-tag :type="getStatusType(scope.row.status)">{{
                            scope.row.status.split("_").join(" ")
                          }}</el-tag>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu class="status-dropdown-menu">
                            <el-dropdown-item
                              v-if="scope.row.status !== 'INACTIVE'"
                              command="INACTIVE"
                              >INACTIVE</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="scope.row.status !== 'ACTIVE'"
                              command="ACTIVE"
                              >ACTIVE</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop=""
                  label="ENABLE EMAIL NOTIFICATIONS"
                  width="210"
                >
                  <template v-slot="{ row }">
                    <div class="text-center-w-100 pr-20">
                      <el-switch
                        v-model="row.settings.email_notifications"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="toggleEmailNotifications($event, row)"
                      >
                      </el-switch>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Case Types"
                  min-width="110"
                  prop="case_types"
                  v-if="hadAllowCaseType"
                >
                  <template #default="scope">
                    <div
                      class="case-type"
                      v-if="
                        scope.row.allowed_case_types &&
                        scope.row.allowed_case_types.length > 1
                      "
                    >
                      <el-dropdown>
                        <span class="case-data-type">
                          {{ getCaseTypes(scope.row.allowed_case_types)[0] }}

                          <img
                            src="@/assets/images/case-type-arrow.svg"
                            alt="icon"
                          />
                        </span>

                        <template #dropdown>
                          <el-dropdown-menu class="case-type-dropdown">
                            <el-dropdown-item
                              class="cases-view"
                              v-for="(caseType, index) of getCaseTypes(
                                scope.row.allowed_case_types
                              )"
                              :key="index"
                            >
                              {{ caseType }}
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                    <div
                      v-else-if="
                        scope.row.allowed_case_types &&
                        scope.row.allowed_case_types.length == 1
                      "
                      class="case-type"
                    >
                      <span class="case-data-type">
                        {{ getCaseTypes(scope.row.allowed_case_types)[0] }}
                      </span>
                    </div>
                    <div v-else></div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  label="ACTIONS"
                  width="100"
                  fixed="right"
                >
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li v-if="hasPermission('user_accounts', 'add')">
                        <el-button
                          class="view-button"
                          @click="onEdit(scope.row)"
                          title="Edit User"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/edit-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/edit-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                      <li v-if="hasPermission('user_accounts', 'add')">
                        <el-button
                          @click="onPasswordReset(scope.row)"
                          class="view-button"
                          title="Reset Password"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/reset-password-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/reset-password-inactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                      <!-- <li v-if="hasPermission('user_accounts', 'add')">
                        <el-button
                          @click="onDeleteUser(scope.row._id)"
                          class="view-button"
                          title="Delete User"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/delete-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/delete-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>  -->
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="listings listings__pagination">
              <el-pagination
                v-model:currentPage="page"
                v-model:page-size="pageSize"
                :page-sizes="[25, 50, 75, 100]"
                layout="prev, pager, next, jumper, sizes, total"
                :total="getAllUsers.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { usersSearchOptions } from "@/config/constants/searchConstants";
import userConstants from "@/config/constants/userConstants";
import caseConstants from "@/config/constants/caseConstants";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";

export default {
  data() {
    return {
      scrollPosition: null,
      physician: "",
      searchBy: "",
      hospital: "",
      userType: "",
      searchOptions: usersSearchOptions,
      search_string: "",
      allUserAccounts: {},
      page: 1,
      pageSize: 25,
      email: false,
      loading: false,
      orderBy: "",
      orderType: "",
      userTypeMap: userConstants.userTypeMap,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      hospitalsData: {},
      hospitalsLoading: false,
    };
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  mixins: [UserPermissionsHelper, FilterHelper],
  computed: {
    ...mapGetters("userAccounts", [
      "getAllUsers",
      "getUserAccountStatusUpdated",
      "getUserAccountErrors",
      "getUserAccountDeleteStatus",
      "getUserPasswordResetStatus",
      "toggleEmailNotificationStatus",
    ]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    getUserTypes() {
      return userConstants.GROUPED_USER_TYPES.filter((userType) => {
        if (userType.allow_to_add.indexOf(this.currentUserType) != -1) {
          userType.options = userType.options.filter(
            (userOptions) =>
              userOptions.allow_to_add.indexOf(this.currentUserType) != -1
          );
          return userType;
        }
      });
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    hadAllowCaseType() {
      if (this.searchBy == "user_type" && this.userType == "LAB_TECHNOLOGIST") {
        return true;
      }
      return false;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "success";
        } else if (status == "INACTIVE") {
          return "danger";
        }
      };
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchAllUserAccounts();
  },
  methods: {
    clearInputSearch() {
      if (
        this.search_string ||
        this.hospital ||
        this.physician ||
        this.userType
      ) {
        this.search_string = "";
        this.hospital = "";
        this.userType = "";
        this.physician = "";
        this.page = 1;
        this.fetchAllUserAccounts();
      }
    },
    async fetchAllHospitals() {
      try {
        this.hospitalsLoading = true;
        await this.$store.dispatch("hospitals/fetchAllHospitals", {
          get_all: true,
        });
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async toggleEmailNotifications(status, user) {
      try {
        this.$confirm(
          `Are you sure to ${
            status ? "Enable" : "Disable"
          } the email notifications to ${user.first_name}`
        )
          .then(async () => {
            await this.toggleNotifyStatus(status, user._id);
          })
          .catch(async () => {
            this.loading = true;
            await this.setUserAccountsData();
            this.loading = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    async toggleNotifyStatus(status, id) {
      try {
        this.loading = true;
        let params = {
          id,
          data: {
            email_notifications: status,
          },
        };
        await this.$store.dispatch(
          "userAccounts/toggleEmailNotifications",
          params
        );
        if (this.toggleEmailNotificationStatus) {
          successNotification(
            `Notifications ${status ? "Enabled" : "Disabled"} successfully`
          );
          await this.fetchAllUserAccounts();
        } else {
          errorNotification(
            this.getError || "Error in update notification settings"
          );
          this.refresh = true;
          setTimeout(() => {
            this.refresh = false;
          }, 500);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    setUserAccountsData() {
      this.allUserAccounts = JSON.parse(JSON.stringify(this.getAllUsers));
      const userSettings = {
        email_notifications: false,
        fax_notifications: false,
      };
      this.allUserAccounts.data.map((user) => {
        user.settings = { ...userSettings, ...user.settings };
      });
    },
    getAutoCompleteUserAccounts() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllUserAccounts();
      }, 600);
    },
    async changeStatus(command, id, index) {
      try {
        let params = {
          status: command,
          id: id,
        };
        await this.$store.dispatch(
          "userAccounts/updateUserAccountStatus",
          params,
          {
            root: true,
          }
        );
        if (this.getUserAccountStatusUpdated) {
          this.$notify({
            type: "success",
            title: "Success",
            message: "User status updatd successfully",
          });
          this.getAllUsers.data[index].status = command;
          window.location.reload();
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          this.$notify({
            type: "error",
            title: "Error",
            message: this.getUserAccountErrors.critical_error,
          });
        } else {
          this.$notify({
            type: "error",
            title: "Error",
            message: "Error at updating user status",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    onEdit(user) {
      this.editUserAccount(user._id);
    },
    editUserAccount(userId) {
      return this.$router.push({
        name: "EditUserAccount",
        params: {
          user_id: userId,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    onDeleteUser(userId) {
      this.$confirm("Are you sure want to DELETE User. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        await this.deleteUser(userId);
      });
    },

    async deleteUser(userId) {
      try {
        await this.$store.dispatch("userAccounts/deleteUserAccount", {
          id: userId,
        });
        if (this.getUserAccountDeleteStatus) {
          successNotification("User deleted successfully");

          this.fetchAllUserAccounts();
        } else {
          errorNotification("Error at deleting user");
        }
      } catch (error) {
        console.log(error);
      }
    },
    onPasswordReset(user) {
      let userId = user._id;
      let userName = user.first_name + " " + user.last_name;

      this.$confirm(
        `Are you sure want to  Reset <b>${
          userName || "User"
        }</b> 's Password. Continue ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        await this.resetPassword(userId);
      });
    },
    async resetPassword(id) {
      try {
        this.loading = true;
        let params = {
          id,
        };
        await this.$store.dispatch(
          "userAccounts/resetUserAccountPassword",
          params
        );
        this.loading = false;
        if (this.getUserPasswordResetStatus) {
          this.$alert(
            "User Password reset Successfully! <br>User will recieve Email with new password !",
            "Success",
            {
              confirmButtonText: "OK",
              dangerouslyUseHTMLString: true,
              callback: () => {
                this.fetchAllUserAccounts();
              },
            }
          );
        } else if (this.getUserAccountErrors) {
          this.$notify.error({
            title: "Error",
            message: this.getUserAccountErrors.critical_error,
          });
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    setQueryParamsData() {
      if (this.$route.query) {
        this.page = this.$route.query.selectedUserPage
          ? parseInt(this.$route.query.selectedUserPage)
          : 1;
        this.pageSize = this.$route.query.selectedUserPageSize
          ? parseInt(this.$route.query.selectedUserPageSize)
          : 25;
        if (this.$route.query.selectedUserSearch) {
          this.search_string = this.$route.query.selectedUserSearch;
        }
        if (this.$route.query.selectedUserSearchBy) {
          this.searchBy = this.$route.query.selectedUserSearchBy;
        }
        if (this.$route.query.selectedUserHospital) {
          this.fetchAllHospitals();
          this.hospital = this.$route.query.selectedUserHospital;
        }
        if (this.$route.query.selectedUserType) {
          this.userType = this.$route.query.selectedUserType;
        }
        if (this.$route.query.selectedUserOrderBy) {
          this.orderBy = this.$route.query.selectedUserOrderBy;
        }
        if (this.$route.query.selectedUserOrderType) {
          this.orderType = this.$route.query.selectedUserOrderType;
        }
        if (this.$route.query.selectedUserSearchName) {
          this.search_string = this.$route.query.selectedUserSearchName;
        }
        if (this.$route.query.selectedUserSearchUserName) {
          this.search_string = this.$route.query.selectedUserSearchUserName;
        }
      }
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string && this.searchBy) {
        params[this.searchBy] = this.search_string;
      }
      if (this.physician) {
        params.physician = this.physician;
      }
      if (this.hospital) {
        params.hospitals = [this.hospital];
      }
      if (this.userType) {
        params.user_type = this.userType;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      params.status = this.selectedStatuses;
      if (!this.isBillingUser) {
        params.user_types = [
          "AR_LEAD",
          "AR_EXECUTIVE",
          "CP_LEAD",
          "CODING_LEAD",
          "CODING_EXECUTIVE",
          "POSTING_EXECUTIVE",
          "SR_FTE",
          "BILLING_REPRESENTATIVE",
        ];
      }
      return params;
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllUserAccounts();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllUserAccounts();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllUserAccounts();
    },
    async fetchAllUserAccounts() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("userAccounts/fetchAllUserAccounts", params);
        this.updateQueryParams(params);
        if (this.getAllUsers) {
          this.setUserAccountsData();
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedUserPage: params.page,
        selectedUserPageSize: params.limit,
        selectedUserSearch: params.search_string,
        selectedUserHospital: params.hospitals,
        selectedUserType: params.user_type,
        selectedUserOrderBy: params.order_by,
        selectedUserOrderType: params.order_type,
        selectedUserSearchBy: this.searchBy || undefined,
        selectedUserSearchName: params.name,
        selectedUserSearchUserName: params.username,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    addUser() {
      this.$router.push({
        name: "addUser",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#user-account-list {
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-default {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
}
</style>
